/**
 * Tiny pub/sub for freshly-arrived messages.
 *
 * Kept separate from the Zustand store so a listener does not have to diff
 * Map identity to notice an append. Published from exactly one place,
 * `useMessengerSubscription`'s `onMessageNew`, which already distinguishes a
 * live arrival from a history load (seed/prepend never call this), an edit
 * (`message:updated` goes through `replaceWireMessage` instead), and a
 * reaction (its own channel event). That is also why no further filtering is
 * needed here: whatever reaches this bus really is a new message landing live.
 */

import type { Message as WireMessage } from './messenger.wire'

type Listener = (message: WireMessage) => void

const listeners = new Set<Listener>()

/** Called once per `message:new` channel event, right after the store is updated. */
export function publishIncomingMessage(message: WireMessage): void {
  for (const fn of listeners) fn(message)
}

/** Subscribe to every incoming message across every joined conversation. Returns
 *  an unsubscribe function. */
export function subscribeIncomingMessages(fn: Listener): () => void {
  listeners.add(fn)
  return () => { listeners.delete(fn) }
}
